// Paleta y utilidades compartidas por los cuatro tableros y el constructor de reportes.
// El color sigue a la entidad, no a su posición: nunca se recicla ni se repinta al filtrar.
// Los valores viven en styles/tokens.css (--chart-cat-N / --chart-seq-N): acá solo se referencian.
export const CATEGORY_COLORS = [
  "var(--chart-cat-1)", "var(--chart-cat-2)", "var(--chart-cat-3)", "var(--chart-cat-4)",
  "var(--chart-cat-5)", "var(--chart-cat-6)", "var(--chart-cat-7)", "var(--chart-cat-8)",
];

const assigned = new Map();
export function colorFor(key) {
  if (assigned.has(key)) return assigned.get(key);
  const color = CATEGORY_COLORS[assigned.size % CATEGORY_COLORS.length];
  assigned.set(key, color);
  return color;
}

export function moneyTick(cents) {
  const v = Number(cents || 0) / 100;
  if (Math.abs(v) >= 1000) return `$${(v / 1000).toFixed(1)}k`;
  return `$${v.toFixed(0)}`;
}

export const PRESETS = ["today", "this_week", "this_month", "last_month", "last_90", "custom"];

export function presetToRange(preset) {
  const now = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  if (preset === "today") {
    return { desde: iso(startOfDay(now)), hasta: iso(now) };
  }
  if (preset === "this_week") {
    const day = now.getDay() || 7;
    const monday = new Date(now);
    monday.setDate(now.getDate() - day + 1);
    return { desde: iso(monday), hasta: iso(now) };
  }
  if (preset === "this_month") {
    return { desde: iso(new Date(now.getFullYear(), now.getMonth(), 1)), hasta: iso(now) };
  }
  if (preset === "last_month") {
    const first = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const last = new Date(now.getFullYear(), now.getMonth(), 0);
    return { desde: iso(first), hasta: iso(last) };
  }
  if (preset === "last_90") {
    const d = new Date(now);
    d.setDate(d.getDate() - 90);
    return { desde: iso(d), hasta: iso(now) };
  }
  return null;
}
